import React, { useState } from 'react'
import { useTaskContext } from '../../../../context/TaskContext';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useMutation } from '@apollo/client';
import { CREATE_PROJECT, PROJECT_UPDATE } from '../../../../apollo/Mutations';
import toast from 'react-hot-toast';
import { set_all_projects } from '../../../../redux/taskSlice';
import sortArrayByKey from '../../../../Utils/useSortedArray';

export default function ProjectModal({ type, open, onClose, onSelectProject, projectEdit, setEditProject }) {
    const dispatch = useDispatch();
    const { OnUpdateTask, isObserver, } = useTaskContext()
    const [search, setSearch] = useState("");


    const { all_projects, active_task } = useSelector((state) => state.task);

    const [searchValue, setSearchValue] = useState('');

    const [create_project_title] = useMutation(CREATE_PROJECT);
    const [project_update] = useMutation(PROJECT_UPDATE);

    const [editTitle, setEditTitle] = useState(active_task?.project_title || '');
    const updateProjectTitle = async () => {
        if (editTitle.trim()) {
            const normalizedEditTitle = editTitle.trim().toLowerCase();
            if (!all_projects.some((f) => f.project_title.toLowerCase() === normalizedEditTitle)) {
                try {
                    const { data } = await project_update({
                        variables: {
                            input: {
                                project_id: active_task?.project_id,
                                project_title: editTitle.trim(),
                            },
                        },
                    });
                    if (data.project_update.status) {
                        toast.success(data.project_update.message);
                        dispatch(
                            set_all_projects(
                                all_projects.map((project) =>
                                    project._id === active_task?.project_id
                                        ? { ...project, project_title: editTitle.trim() }
                                        : project
                                )
                            )
                        );
                        OnUpdateTask({
                            project_id: active_task?.project_id,
                            project_title: editTitle.trim(),
                            save_type: 'project_title',
                        });
                        setEditProject(false)
                    }
                } catch (error) {
                    console.error(error);
                    toast.error('Failed to update the project title. Please try again.');
                }
            } else {
                toast.error(`${editTitle} already exists.`);
            }
        }
    }

    const handleAddTitle = async () => {
        try {
            const normalizedTitle = search.trim().toLowerCase();
            if (!all_projects.some((f) => f.project_title.toLowerCase() === normalizedTitle)) {
                const { data } = await create_project_title({
                    variables: { input: { project_title: search } },
                });
                toast.success(data.create_project.message);
                let d = {
                    _id: data.create_project.data[0]._id,
                    project_title: data.create_project.data[0].project_title,
                }
                dispatch(set_all_projects([d, ...all_projects]));
                setSearch('');
                handleSelectTitle(d);
            } else {
                toast.error(`${search} already exists.`);
            }
        } catch (error) {
            console.error(error);
            toast.error('Failed to add the project. Please try again.');
        }
    };

    const handleSelectTitle = (project) => {
        // setSelected_project(project);
        if (type === 'create') {
            onSelectProject(project);
            onClose();
        } else {

            OnUpdateTask({
                project_id: project._id,
                project_title: project.project_title,
                save_type: 'project_title',
            });
        }
    };

    // Filtered and sorted projects
    const filteredProjects = all_projects?.filter(
        (project) =>
            project._id !== 'all' &&
            project.project_title.toLowerCase().includes(search.trim().toLowerCase() || searchValue.trim().toLowerCase())
    );
    const sorted_data = sortArrayByKey(filteredProjects, 'project_title', 'asc');
    const filtered = sorted_data.filter(f => f._id !== 'all' && f.project_title?.trim() !== '' && f._id !== active_task?.project_id);
    const canCreate = search.trim() !== "" && !sorted_data.some(k => k.project_title.toLowerCase() === search.trim().toLowerCase()) && !sorted_data.includes(search.trim());



    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-end justify-center">
            {/* Backdrop */}
            <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />

            {/* Sheet */}
            <div className="relative w-full max-w-sm bg-white rounded-t-3xl shadow-2xl pb-safe"
                style={{ animation: "slideUp 0.25s cubic-bezier(0.32,0.72,0,1)" }}>

                <style>
                    {`
                        @keyframes slideUp {
                            from { transform: translateY(100%); opacity: 0; }
                            to   { transform: translateY(0);    opacity: 1; }
                        }
                        @keyframes chipIn {
                            from { transform: scale(0.7); opacity: 0; }
                            to   { transform: scale(1);   opacity: 1; }
                        }
                        .chip-enter { animation: chipIn 0.18s cubic-bezier(0.34,1.56,0.64,1) forwards; }
                    `}
                </style>

                {/* Drag handle */}
                <div className="flex justify-center pt-3 pb-1">
                    <div className="w-10 h-1 bg-slate-200 rounded-full" />
                </div>

                {/* Header */}
                <div className="flex items-center justify-between px-5 pt-3 pb-4">
                    <div>
                        <h2 className="text-base font-bold text-slate-800">Projects</h2>
                        <p className="text-xs text-slate-400 mt-0.5">Select a project to organize this task</p>
                    </div>
                    <button onClick={onClose}
                        className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center hover:bg-slate-200 transition-colors">
                        <svg className="w-4 h-4 text-slate-500" fill="none" viewBox="0 0 24 24">
                            <path d="M6 18L18 6M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </button>
                </div>


                <div className="px-5 pb-4">
                    <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-2">Active</p>
                    <div className="flex flex-wrap gap-2">
                        <div className="chip-enter flex items-center gap-1.5 bg-violet-50 border border-violet-200 rounded-full pl-3 pr-2 py-1">
                            <span className="text-xs font-semibold text-violet-700">{sorted_data.find(f => f._id === active_task?.project_id)?.project_title}</span>
                        </div>
                    </div>
                </div>

                {/* Divider */}
                <div className="mx-5 border-t border-slate-100 mb-4" />

                {/* Search input */}
                <div className="px-5 mb-3">
                    <div className="relative">
                        <svg className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" fill="none" viewBox="0 0 24 24">
                            <path d="M21 21l-4.35-4.35M17 11A6 6 0 115 11a6 6 0 0112 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                        <input
                            autoFocus
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            placeholder="Search or create project..."
                            className="w-full bg-slate-50 border border-slate-200 rounded-2xl pl-10 pr-9 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-violet-400 focus:bg-white transition-all placeholder-slate-300"
                        />
                        {search && (
                            <button onClick={() => setSearch("")}
                                className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 rounded-full bg-slate-200 flex items-center justify-center hover:bg-slate-300 transition-colors">
                                <svg className="w-3 h-3 text-slate-500" fill="none" viewBox="0 0 24 24">
                                    <path d="M6 18L18 6M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                            </button>
                        )}
                    </div>
                </div>

                {/* Suggestions list */}
                <div className="px-5 overflow-y-auto" style={{ maxHeight: "200px" }}>
                    {filtered?.length > 0 ?
                        <div className="space-y-0.5">
                            {filtered?.map((project, index) => (
                                <button key={project._id} onClick={() => { setSearch(''); handleSelectTitle(project) }}
                                    className="w-full flex items-center justify-between px-3 py-2.5 rounded-xl hover:bg-violet-50 transition-colors group text-left">
                                    <span className="text-sm text-slate-700 group-hover:text-violet-700 font-medium transition-colors">
                                        {project.project_title}
                                    </span>
                                    <svg className="w-4 h-4 text-slate-300 group-hover:text-violet-500 transition-colors" fill="none" viewBox="0 0 24 24">
                                        <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </button>
                            ))}
                        </div>
                        : canCreate ? (
                            <button
                                onClick={handleAddTitle}
                                className="w-full flex items-center gap-3 px-3 py-3 rounded-xl bg-violet-50 border border-dashed border-violet-300 hover:border-violet-500 hover:bg-violet-100 transition-all group">
                                <div className="w-7 h-7 rounded-full bg-violet-100 group-hover:bg-violet-200 flex items-center justify-center transition-colors shrink-0">
                                    <svg className="w-3.5 h-3.5 text-violet-600" fill="none" viewBox="0 0 24 24">
                                        <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <div className="text-left">
                                    <p className="text-xs text-slate-400">Create new project</p>
                                    <p className="text-sm font-semibold text-violet-700">"{search}"</p>
                                </div>
                            </button>
                        ) : (
                            <div className="flex flex-col items-center py-6 text-center">
                                <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center mb-2">
                                    <svg className="w-5 h-5 text-slate-300" fill="none" viewBox="0 0 24 24">
                                        <path d="M7 7h10M7 12h10M7 17h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <p className="text-xs text-slate-400">No projects found</p>
                                <p className="text-xs text-slate-300 mt-0.5">Try a different search term</p>
                            </div>
                        )}
                </div>

                {/* Bottom padding for safe area */}
                <div className="h-6" />
            </div>
        </div>
    );
}
